/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ConfirmedActionItemDto
 */
export interface ConfirmedActionItemDto {
  /**
   *
   * @type {string}
   * @memberof ConfirmedActionItemDto
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof ConfirmedActionItemDto
   */
  assignee: string;
  /**
   *
   * @type {LocalDate}
   * @memberof ConfirmedActionItemDto
   */
  deadline?: LocalDate | null;
}

/**
 * Check if a given object implements the ConfirmedActionItemDto interface.
 */
export function instanceOfConfirmedActionItemDto(
  value: object,
): value is ConfirmedActionItemDto {
  if (!("title" in value) || value["title"] === undefined) return false;
  if (!("assignee" in value) || value["assignee"] === undefined) return false;
  return true;
}

export function ConfirmedActionItemDtoFromJSON(
  json: any,
): ConfirmedActionItemDto {
  return ConfirmedActionItemDtoFromJSONTyped(json, false);
}

export function ConfirmedActionItemDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConfirmedActionItemDto {
  if (json == null) {
    return json;
  }
  return {
    title: json["title"],
    assignee: json["assignee"],
    deadline: json["deadline"] == null ? undefined : json["deadline"],
  };
}

export function ConfirmedActionItemDtoToJSON(
  json: any,
): ConfirmedActionItemDto {
  return ConfirmedActionItemDtoToJSONTyped(json, false);
}

export function ConfirmedActionItemDtoToJSONTyped(
  value?: ConfirmedActionItemDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    title: value["title"],
    assignee: value["assignee"],
    deadline: value["deadline"],
  };
}
